import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=8b6f8a48&scoped=true&"
import script from "./Banner.vue?vue&type=script&lang=js&"
export * from "./Banner.vue?vue&type=script&lang=js&"
import style0 from "./Banner.vue?vue&type=style&index=0&id=8b6f8a48&lang=less&scoped=true&"
import style1 from "./Banner.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6f8a48",
  null
  
)

export default component.exports